/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ThemeEnum = (typeof ThemeEnum)[keyof typeof ThemeEnum];

export const ThemeEnum = {
  "mental-health": "mental-health",
  sleep: "sleep",
  "gut-health": "gut-health",
  thyroid: "thyroid",
  "weight-loss": "weight-loss",
  nutrition: "nutrition",
  "symptom-checking": "symptom-checking",
  menopause: "menopause",
  "improving-weight": "improving-weight",
  "weight-loss-plans": "weight-loss-plans",
  "medical-treatments-for-weight-loss": "medical-treatments-for-weight-loss",
  "improving-menopause-symptoms": "improving-menopause-symptoms",
  "understanding-menopause-symptoms": "understanding-menopause-symptoms",
  "medical-treatments-for-menopause": "medical-treatments-for-menopause",
  "uti-relief": "uti-relief",
  "talk-to-a-doctor": "talk-to-a-doctor",
  "online-prescription-refill": "online-prescription-refill",
  "free-diagnosis-online": "free-diagnosis-online",
  "online-uti-treatment": "online-uti-treatment",
  "glp-1-program": "glp-1-program",
  "bill-negotiation": "bill-negotiation",
  "prior-auth-reversal": "prior-auth-reversal",
} as const;
